module.exports = __webpack_public_path__ + "img/w3_circle_close_dark.e7c44c4e.e7c44c4e.png";